export default __webpack_public_path__ + "8389839efd65bfa8824b9b7d229067aa.svg";